<div class="filter-product hidden w-80 md:block">
  <h2 class="text-lg font-medium">Filter</h2>
  <div class="mt-3 w-80 rounded-lg border border-gray-100 shadow-sm">
    <div class="filter-sale rounded-md">
      <div
        (click)="onSaleFilter()"
        class="card-header flex cursor-pointer items-center justify-between border-b py-2 px-4">
        <h3 class="font-semibold">Sale</h3>
        <span class="flex h-3 w-3">
          <span class="relative inline-flex h-3 w-3 rounded-full bg-red-500">
            <span
              class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="filter-brand rounded-md">
      <div
        class="card-header flex cursor-pointer items-center justify-between border-b py-2 px-4"
        (click)="showBrand = !showBrand">
        <h3 class="font-semibold">Brand</h3>
        <button
          type="button"
          class="flex-none rounded-full py-1 px-2 hover:bg-slate-100"
          [ngClass]="{ 'rotate-180 transform': showBrand }">
          <fa-icon [icon]="faChevronDown" class="text-gray-500"></fa-icon>
        </button>
      </div>
      <div
        [ngClass]="!showBrand ? 'hidden' : ''"
        class="card-body border-b"
        style="transform-origin: center top">
        <ul class="grid max-h-60 gap-3 overflow-y-auto py-3 px-4">
          <li class="flex items-center gap-5" *ngFor="let brand of brands">
            <input
              type="checkbox"
              class="scale-[1.75] cursor-pointer accent-primary-darkest"
              [checked]="checkedBrand(brand)"
              [id]="'brand' + brand.id"
              (change)="onSelectBrand(brand)" />
            <label class="flex-1 cursor-pointer" [for]="'brand' + brand.id">{{
              brand.name
            }}</label>
          </li>
          <p-skeleton *ngIf="!brands.length" class="h-2 w-full"></p-skeleton>
        </ul>
      </div>
    </div>
    <div class="filter-category rounded-md">
      <div
        class="card-header flex cursor-pointer items-center justify-between border-b py-2 px-4"
        (click)="showCategory = !showCategory">
        <h3 class="font-semibold">Category</h3>
        <button
          type="button"
          class="flex-none rounded-full py-1 px-2 hover:bg-slate-100"
          [ngClass]="{ 'rotate-180 transform': showCategory }">
          <fa-icon [icon]="faChevronDown" class="text-gray-500"></fa-icon>
        </button>
      </div>
      <div
        [ngClass]="!showCategory ? 'hidden' : ''"
        class="card-body border-b"
        style="transform-origin: center top">
        <ul class="max-h-60 overflow-y-auto py-3 px-4">
          <li *ngFor="let category1 of categories; let i = index">
            <div
              class="flex cursor-pointer items-center justify-end rounded-lg p-1 hover:bg-gray-100"
              (click)="category1.show_children = !category1.show_children">
              <button
                type="button"
                class="flex-1 items-center gap-2 text-sm"
                *ngIf="category1.children.length"
                [ngClass]="{
                  'rotate-180 transform': category1.show_children == true
                }">
                <fa-icon
                  [icon]="faChevronDown"
                  class="rotate-180 text-gray-500"></fa-icon>
              </button>
              <span
                class="w-11/12 truncate"
                (click)="setSelectedCategory(category1.slug)"
                [ngClass]="{
                  'font-bold': selectedCategorySlugs.includes(category1.slug)
                }">
                {{ category1.name }}
              </span>
            </div>
            <ng-container
              *ngIf="
                category1.children.length && category1.show_children == true
              ">
              <ul class="py-1 pl-4">
                <li *ngFor="let category2 of category1.children; let j = index">
                  <div
                    class="flex cursor-pointer items-center justify-end rounded-lg p-1 hover:bg-gray-100"
                    (click)="
                      category2.show_children = !category2.show_children
                    ">
                    <button
                      type="button"
                      class="flex-1 items-center gap-2 text-sm"
                      *ngIf="category2.children.length"
                      [ngClass]="{
                        'rotate-180 transform': category2.show_children == true
                      }">
                      <fa-icon
                        [icon]="faChevronDown"
                        class="rotate-180 text-gray-500"></fa-icon>
                    </button>
                    <span
                      class="w-11/12 truncate"
                      [ngClass]="{
                        'font-bold': selectedCategorySlugs.includes(
                          category2.slug
                        )
                      }"
                      (click)="
                        setSelectedCategory(category1.slug, category2.slug)
                      ">
                      {{ category2.name }}
                    </span>
                  </div>
                  <ng-container
                    *ngIf="
                      category2.children.length &&
                      category2.show_children == true
                    ">
                    <ul class="py-1 pl-4">
                      <li
                        *ngFor="
                          let category3 of category2.children;
                          let k = index
                        ">
                        <div
                          class="flex cursor-pointer items-center justify-end rounded-lg p-1 hover:bg-gray-100"
                          (click)="
                            category3.show_children = !category3.show_children
                          ">
                          <span
                            class="w-11/12 truncate"
                            [ngClass]="{
                              'font-bold': selectedCategorySlugs.includes(
                                category3.slug
                              )
                            }"
                            (click)="
                              setSelectedCategory(
                                category1.slug,
                                category2.slug,
                                category3.slug
                              )
                            ">
                            {{ category3.name }}
                          </span>
                        </div>
                      </li>
                    </ul>
                  </ng-container>
                </li>
              </ul>
            </ng-container>
          </li>
          <p-skeleton
            *ngIf="!categories.length"
            class="h-2 w-full"></p-skeleton>
        </ul>
      </div>
    </div>
    <div class="filter-price rounded-md">
      <div
        class="card-header flex cursor-pointer items-center justify-between border-b py-2 px-4"
        (click)="showPrice = !showPrice">
        <h3 class="font-semibold">Price</h3>
        <button
          type="button"
          class="flex-none rounded-full py-1 px-2 hover:bg-slate-100"
          [ngClass]="{ 'rotate-180 transform': showPrice }">
          <fa-icon [icon]="faChevronDown" class="text-gray-500"></fa-icon>
        </button>
      </div>
      <div
        [ngClass]="!showPrice ? 'hidden' : ''"
        class="card-body space-y-3 border-b p-3"
        style="transform-origin: center top">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Rp</span>
          <p-inputNumber
            placeholder="Lowest Price"
            mode="decimal"
            locale="id-ID"
            [minFractionDigits]="2"
            [(ngModel)]="minPriceInput"
            (keyup)="onInputPrice()">
          </p-inputNumber>
        </div>
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">Rp</span>
          <p-inputNumber
            placeholder="Highest Price"
            mode="decimal"
            locale="id-ID"
            [minFractionDigits]="2"
            [(ngModel)]="maxPriceInput"
            (keyup)="onInputPrice()">
          </p-inputNumber>
        </div>
        <div class="quick-price space-y-3">
          <button
            type="button"
            class="btn btn-sm block rounded-full border py-1 px-3 text-gray-500 hover:text-gray-700"
            [ngClass]="{
              'bg-gray-100':
                quickPrice.minPrice == selectedPriceRange.minPrice &&
                quickPrice.maxPrice == selectedPriceRange.maxPrice
            }"
            *ngFor="let quickPrice of quickPrices"
            (click)="onQuickPrice(quickPrice.minPrice, quickPrice.maxPrice)">
            {{ quickPrice.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="filter-product-mobile md:hidden">
  <button
    type="button"
    class="flex items-center gap-3 rounded-full border px-3 py-1 text-sm">
    <fa-icon [icon]="faFilter" class="text-gray-500"></fa-icon>
    <span>Filter</span>
  </button>
</div>
